import Link from 'next/link';
import Container from 'components/container';

import { LIBUM_DOCS_GLACI, LIBUM_DOCS_NEXUM, LIBUM_DOCS_POWERON_PRO, LIBUM_URL } from 'shared/constants/globals';
import {
  ContentHeadline,
  ContentList,
  ContentListItem,
  ContentListItemMeta,
  ContentMain,
  ContentPanel,
} from 'shared/styles/components';
import { handleExternallLink } from 'shared/constants/utilities';

import EXTERNAL_LINK_ICON from 'public/icons/eva/external_link.svg';

interface DocsItem {
  id: string;
  title: string;
  description: string;
  label: string;
  href: string;
  isEnabled: boolean;
}

export default function Docs() {
  const title = 'Docs | Libum';
  const description = 'Explore our guides and examples on how to get started with all of our products.';
  const keywords = 'Libum,Libum docs,NexumAPI docs,PowerOn Pro docs,Glaci docs,Jack Henry docs,Symitar docs';
  const url = `${LIBUM_URL}/docs`;

  const DOCS_ITEMS: DocsItem[] = [
    {
      id: 'nexum-docs',
      title: 'NexumAPI Docs',
      description: `NexumAPI can be used in lieu of any SymXchange request. We offer a completely JSON-encoded alternative to SOAP, as well as access to a growing list of additional features.`,
      label: 'Available',
      href: LIBUM_DOCS_NEXUM,
      isEnabled: true,
    },
    {
      id: 'poweron-pro-docs',
      title: 'PowerOn Pro Docs',
      description: `PowerOn Pro is a Visual Studio Code Extension created to give developers all of the tools they'd need to efficiently write, run, and debug PowerOn code for the Jack Henry credit union core system, Symitar.`,
      label: 'Available (Pre-Release)',
      href: LIBUM_DOCS_POWERON_PRO,
      isEnabled: true,
    },
    {
      id: 'glaci-docs',
      title: 'Glaci Docs',
      description:
        'Glaci is an overlay for Symitar Quest which brings blazing fast and beautiful UIs as well as incredible functionality to your credit union stack.',
      label: 'Coming Soon',
      href: LIBUM_DOCS_GLACI,
      isEnabled: false,
    },
  ];

  return (
    <Container title={title} description={description} keywords={keywords} url={url} socialCard="docs">
      <div style={{ width: '100%' }}>
        <ContentPanel>
          <ContentHeadline>
            <h1>Docs</h1>
            <p>Find the quickstarts for any one of our products.</p>
          </ContentHeadline>
        </ContentPanel>
        <ContentPanel>
          <ContentMain>
            <ContentList>
              {...DOCS_ITEMS.map((item) => (
                <ContentListItem key={item.id}>
                  <h3>
                    <Link href="" onClick={(e: any) => handleExternallLink(e, item.href)}>
                      {item.title}
                      <EXTERNAL_LINK_ICON />
                    </Link>
                  </h3>
                  <p>{item.description}</p>
                  <ContentListItemMeta>
                    <span>{item.label}</span>
                  </ContentListItemMeta>
                </ContentListItem>
              ))}
            </ContentList>
          </ContentMain>
        </ContentPanel>
      </div>
    </Container>
  );
}
